import moment from "moment";
import { useState } from "react";
// import { useDispatch } from "react-redux";
import { showErrorDialog } from "./dialog";

import { env } from "../../env";
import CryptoJS from "crypto-js";

export const GOOGLE_KEY = `${env.REACT_APP_API_KEY}`;

export const sizePerPageList = (totalSize) => [
  {
    text: "10",
    value: 10,
  },
  {
    text: "20",
    value: 20,
  },
  {
    text: "30",
    value: 30,
  },
  {
    text: "40",
    value: 40,
  },
  {
    text: "50",
    value: 50,
  },
  // {
  //   text: "All",
  //   value: totalSize,
  // },
];

export const sizePerPageList2 = (totalSize) => [
  {
    text: "10",
    value: 10,
  },
  {
    text: "20",
    value: 20,
  },
  {
    text: "30",
    value: 30,
  },
  {
    text: "40",
    value: 40,
  },
  {
    text: "50",
    value: 50,
  },
  {
    text: "All",
    value: -1,
  },
];

export const allMounth = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const allDay = [
  { label: "Senin", value: "Senin" },
  { label: "Selasa", value: "Selasa" },
  { label: "Rabu", value: "Rabu" },
  { label: "Kamis", value: "Kamis" },
  { label: "Jumat", value: "Jumat" },
  { label: "Sabtu", value: "Sabtu" },
  { label: "Minggu", value: "Minggu" },
];

export const hari = [];

export const useForceUpdate = () => {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};

export const formatDate = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else if (stringDate === undefined) {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00") {
    return "";
  } else {
    return moment(stringDate).format("DD/MMM/YYYY");
  }
};
export const formatDateTime = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else if (stringDate === undefined) {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00") {
    return "";
  } else {
    return moment(stringDate).format("DD/MMM/YYYY - HH:mm");
  }
};

export const formatTime = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else if (stringDate === undefined) {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00") {
    return "";
  } else {
    return moment(stringDate).format("HH:mm");
  }
};

export const formatDateMonth = (stringDate, row) => {
  if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else if (stringDate === undefined) {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00") {
    return "";
  } else {
    return moment(stringDate).format("DD MMMM YYYY");
  }
};
export const formatDateMonthOrderList = (stringDate, row) => {
  if (stringDate === null) {
    return "";
  } else if (row.type === "TENTATIVE ORDER") {
    return moment(stringDate).format(" MMM YYYY");
  } else {
    return moment(stringDate).format("DD MMM YYYY");
  }
};

export const formatShortDate = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else {
    return moment(stringDate).format("YYYY-MM-DD");
  }
};

export const formatDateLocal = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else {
    return moment(stringDate).format("LT");
  }
};

export const formatTimeAttributes = (dataArray) => {
  return dataArray.map((item) => {
    let dFrom = new Date(item.lstoP_DFROM);
    let dTo = new Date(item.lstoP_DATTO);

    let formattedDFrom = dFrom.toLocaleTimeString([], {
      hourCycle: "h23",
      hour: "2-digit",
      minute: "2-digit",
    });

    let formattedDTo = dTo.toLocaleTimeString([], {
      hourCycle: "h23",
      hour: "2-digit",
      minute: "2-digit",
    });

    return {
      ...item,
      lstoP_DFROM: formattedDFrom,
      lstoP_DATTO: formattedDTo,
    };
  });
};

export const isDateFormat = (str) => {
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return dateFormatRegex.test(str);
};

export const parseDateString = (str) => {
  return new Date(str);
};

export const getValueOptions = (value, options) => {
  const return_value = options.filter((val) => value === val.value);
  return return_value;
};

export const checkPermision = (permission, allowedPermission) => {
  return permission.some((e) => allowedPermission.includes(e));
};

export const CallApi = async (id, api, dispatch) => {
  try {
    const response = await dispatch(api(id));
    if (response.payload.status === 200) {
    } else {
      return showErrorDialog(response.payload.data.message);
    }
  } catch (error) {
    showErrorDialog(error.message);
  }
};

export const CallApiExport = async (params, api, dispatch, name) => {
  try {
    const response = await dispatch(api(params));
    if (response.payload.status === 200) {
      const blob = new Blob([response.payload.data], {
        type: "application/xlsx",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.xlsx`;
      link.click();
    } else {
      showErrorDialog(response.payload.data.message);
      console.log("else");
    }
  } catch (error) {
    console.log("catch");
    showErrorDialog(error.message);
  }
};

export const getValueStatus = (value, options) => {
  const return_value = options.filter((val) => value === val.value);
  return return_value;
};

export const createChangeHandler = (setState) => {
  return (e) => {
    if (e === null) {
      e = undefined;
      setState("");
    } else {
      setState(e.value);
    }
  };
};

export let currentDate = new Date();
export let year = currentDate.getFullYear();
export let month = currentDate.getMonth() + 1;
export let day = currentDate.getDate();
export let hours = currentDate.getHours();
export let minutes = currentDate.getMinutes();
export let seconds = currentDate.getSeconds();

// Menambahkan nol di depan angka bulan jika kurang dari 10
if (month < 10) {
  month = "0" + month;
}

// Menambahkan nol di depan angka hari jika kurang dari 10
if (day < 10) {
  day = "0" + day;
}

// Menambahkan nol di depan angka jam jika kurang dari 10
if (hours < 10) {
  hours = "0" + hours;
}

// Menambahkan nol di depan angka menit jika kurang dari 10
if (minutes < 10) {
  minutes = "0" + minutes;
}

// Menambahkan nol di depan angka detik jika kurang dari 10
if (seconds < 10) {
  seconds = "0" + seconds;
}

export const defaultDate = year + "-" + month + "-" + day;

export const defaultDateTime =
  year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;

// Mendapatkan tanggal awal bulan ini
export const awalBulan = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1
);

// Mendapatkan tanggal akhir bulan ini
export const akhirBulan = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() + 1,
  0
);

// Fungsi untuk memformat tanggal ke YYYY-MM-DD
export const formatTanggal = (date) => {
  const tahun = date.getFullYear();
  const bulan = String(date.getMonth() + 1).padStart(2, "0"); // Bulan ditambahkan 1 karena getMonth() mengembalikan 0-11
  const hari = String(date.getDate()).padStart(2, "0");
  return `${tahun}-${bulan}-${hari}`;
};

export const filterDataDesc = (data, keyword) => {
  return data.filter((item) => item.field_descr.includes(keyword));
};

export const setOptionsSelect = (dataSynch, fieldName, stateSetter) => {
  const data = filterDataDesc(dataSynch, fieldName);
  const options =
    data.length > 0
      ? data[0].custom_field_options.map((item) => ({
          label: item.option_label,
          value: item.option_value,
        }))
      : [];
  stateSetter(options);
};

export const setOptionsMaster = (data, stateSetter, id, name) => {
  const options =
    data.length > 0
      ? data.map((item) => ({
          label: item[name],
          value: item[id],
        }))
      : [];
  stateSetter(options);
};

export const setOptionsMaster2 = (data, stateSetter, id, fields) => {
  const options =
    data.length > 0
      ? data.map((item) => ({
          label: fields.map((field) => item[field]).join(" - "), // Gunakan '-' sebagai pemisah
          value: item[id],
        }))
      : [];
  stateSetter(options);
};

export function getValueOptionsMultiple(data, options) {
  let output = [];
  data.map((val) => {
    const result = options.filter((data) => val === data.value);
    output.push(result[0]);
  });
  return output;
}

export const paramsMasterAll = {
  pageNo: 1,
  pageSize: -1,
};

export const paramsCustomerType = [
  {
    value: "CREDIT",
    label: "Credit",
  },
  {
    value: "CASH",
    label: "Cash",
  },
];

export const paramsActiveType = [
  {
    value: true,
    label: "Active",
  },
  {
    value: false,
    label: "In Active",
  },
];
export const paramsCustomerStatus = [
  {
    value: "Permanent",
    label: "Permanent",
  },
  {
    value: "Mobile",
    label: "Mobile",
  },
];

export const paramsCalculationType = [
  {
    value: "AFTER",
    label: "After",
  },
  {
    value: "BEFORE",
    label: "Before",
  },
];
export const paramsYesNoType = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const crashType = [
  {
    value: "web",
    label: "Web",
  },
  {
    value: "mobile",
    label: "Mobile",
  },
];

export const paramsYesNoType2 = [
  {
    value: "Y",
    label: "Yes",
  },
  {
    value: "N",
    label: "No",
  },
];

export const paramsONOFFType = [
  {
    value: true,
    label: "ON",
  },
  {
    value: false,
    label: "OFF",
  },
];
export const paramsONOFF = [
  {
    value: "ON",
    label: "ON",
  },
  {
    value: "OFF",
    label: "OFF",
  },
];

export const paramsSettingNIK = [
  {
    value: "BOTH",
    label: "BOTH",
  },
  {
    value: "ONE",
    label: "ONE",
  },
  {
    value: "NONE",
    label: "NONE",
  },
];

export const paramsSettingPHOTO = [
  {
    value: "BOTH",
    label: "BOTH",
  },
  {
    value: "ONE",
    label: "ONE",
  },
  {
    value: "NONE",
    label: "NONE",
  },
  {
    value: "REMARKS",
    label: "REMARKS",
  },
];

export const paramsUserType = [
  {
    value: "Taking Order",
    label: "Taking Order",
  },
  {
    value: "Canvasing",
    label: "Canvasing",
  },
];

export const getLabel = (index) => ({
  text: String(index + 1), // Mengubah index ke angka (dimulai dari 1)
  color: "white", // Menambahkan warna putih pada teks
  fontWeight: "bold", // Menambahkan ketebalan font
});
export const getLabelOnly = (index) => ({
  text: String(index + 1), // Mengubah index ke angka (dimulai dari 1)
});
export const paramsStatusCrash = [
  {
    value: "NEW",
    label: "NEW",
  },
  {
    value: "IN_PROGRESS",
    label: "IN PROGRESS",
  },
  {
    value: "REVIEW",
    label: "REVIEW",
  },
  {
    value: "RESOLVED",
    label: "RESOLVED",
  },
];
export const paramsMethod = [
  {
    value: "GET",
    label: "GET",
  },
  {
    value: "POST",
    label: "POST",
  },
  {
    value: "PUT",
    label: "PUT",
  },
  {
    value: "DELETE",
    label: "DELETE",
  },
];
export const paramsAPI = [
  {
    value: "SUCCESS",
    label: "SUCCESS",
  },
  {
    value: "FAILED",
    label: "FAILED",
  },
];
export const paramsStatus = [
  {
    value: "OPEN",
    label: "Open",
  },
  {
    value: "CLOSED",
    label: "Closed",
  },
];

export const paramsStatusSellIn = [
  {
    value: "DRAFT",
    label: "Draft",
  },
  {
    value: "CONFIRM",
    label: "Confirm",
  },
];

export const paramsStatusJourney = [
  {
    value: "STARTED",
    label: "STARTED",
  },
  {
    value: "NOT STARTED",
    label: "NOT STARTED",
  },
  {
    value: "END JOURNEY",
    label: "END JOURNEY",
  },
];

export const checkEmptyFields = (fields) => {
  const isEmpty = fields.some(
    (field) =>
      (field.value === "" ||
        field.value === null ||
        field.value === undefined) &&
      field.valid === true
  );
  if (isEmpty) {
    const emptyField = fields.find(
      (field) =>
        (field.value === "" ||
          field.value === null ||
          field.value === undefined) &&
        field.valid === true
    );
    return `Please ${emptyField.message}`;
  }
  return null;
};

export const validatePrice = (price) => {
  return parseFloat(price) > 0; // Check if price is greater than 0
};

// export const encryptData = (data) => {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
// };

// export const decryptData = (encryptedData) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// };

export const getSlat = (obj) => {
  const exponent3 = 3;
  const exponent2 = 2;
  const exponent = 1;

  const resultDay = Math.pow(day, exponent3);
  const resultMonth = Math.pow(month, exponent2);
  const resultYear = Math.pow(year, exponent);

  return `${resultDay}${resultMonth}${resultYear}`;
};

export const key = getSlat();

export const encrypt = (text) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    iv: iv,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  });
  return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
};

export const decrypt = (cipherText) => {
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText),
  });
  const iv = cipherParams.ciphertext.clone();
  iv.sigBytes = 16;
  iv.clamp();
  cipherParams.ciphertext.words.splice(0, 4); // Remove first 4 words (16 bytes)
  cipherParams.ciphertext.sigBytes -= 16;

  const decrypted = CryptoJS.AES.decrypt(
    cipherParams,
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: iv,
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.NoPadding,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const getRandomColor = () => {
  const r = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  const g = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  const b = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  return `rgba(${r}, ${g}, ${b}, 0.2)`;
};

export const getRandomBorderColor = () => {
  const r = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  const g = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  const b = Math.floor(Math.random() * 56) + 200; // Menghasilkan nilai antara 200 dan 255
  return `rgba(${r}, ${g}, ${b}, 1)`;
};

export const replaceNulls = (obj) => {
  const newObj = {};
  for (const key in obj) {
    newObj[key] = obj[key] !== null ? obj[key] : "";
  }
  return newObj;
};

export const generateTimestamp = () => {
  const currentTimestamp = Date.now(); // Gets the current timestamp in milliseconds as an integer

  const offset = -new Date().getTimezoneOffset(); // Get timezone offset in minutes and negate it for correct sign
  const hours = Math.floor(offset / 60); // Convert offset to hours
  const minutes = offset % 60; // Get remaining minutes
  const timezone = `${hours >= 0 ? "+" : "-"}${String(Math.abs(hours)).padStart(
    2,
    "0"
  )}:${String(minutes).padStart(2, "0")}`; // Format timezone

  return { timestamp: currentTimestamp, timezone: timezone };
};

export const timestamp = generateTimestamp();

export const addNumber = (items) =>
  items?.map((item, index) => ({
    ...item,
    no: index + 1,
  })) ?? [];

export const optionStatus = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Inactive",
    value: false,
  },
];
export const colorsPie = [
  "#FF6384", // Merah
  "#36A2EB", // Biru
  "#FFCE56", // Kuning
  "#4BC0C0", // Cyan
  "#9966FF", // Ungu
  "#FF9F40", // Oranye
  "#FF5733", // Merah Tua
  "#C70039", // Merah Muda
  "#900C3F", // Merah Anggur
  "#581845", // Ungu Tua
];

export const colorsRandom = [
  "#FF6384", // Merah
  "#36A2EB", // Biru
  "#FFCE56", // Kuning
  "#4BC0C0", // Cyan
  "#9966FF", // Ungu
  "#FF9F40", // Oranye
  "#FF5733", // Merah Tua
  "#C70039", // Merah Muda
  "#900C3F", // Merah Anggur
  "#581845", // Ungu Tua
  "#1F77B4", // Biru Laut
  "#AEC7E8", // Biru Muda
  "#FF7F0E", // Oranye Tua
  "#FFBB78", // Oranye Muda
  "#2CA02C", // Hijau
  "#98DF8A", // Hijau Muda
  "#D62728", // Merah Tua
  "#FF9896", // Merah Muda Terang
  "#9467BD", // Ungu Gelap
  "#C5B0D5", // Ungu Muda
  "#8C564B", // Coklat Tua
  "#C49C94", // Coklat Muda
  "#E377C2", // Merah Muda Terang
  "#F7B6D2", // Merah Muda Lembut
  "#7F7F7F", // Abu-Abu
  "#C7C7C7", // Abu-Abu Terang
  "#BCBD22", // Kuning Hijau
  "#DBDB8D", // Hijau Lemon
  "#17BECF", // Biru Langit
  "#9EDAE5", // Biru Muda Lembut
  "#F94144", // Merah Menyala
  "#F3722C", // Oranye Cerah
  "#F8961E", // Oranye Karamel
  "#F9C74F", // Kuning Terang
  "#90BE6D", // Hijau Cerah
  "#43AA8B", // Hijau Laut
  "#577590", // Biru Laut Tua
  "#F4A261", // Oranye Pasir
  "#2A9D8F", // Teal
  "#264653", // Biru Gelap
  "#E76F51", // Oranye Merah
  "#D62828", // Merah Tua Gelap
  "#023047", // Biru Gelap Kuat
  "#FB8500", // Oranye Menyala
  "#8D99AE", // Abu-Abu Kebiruan
  "#EF233C", // Merah Terang
  "#FFB703", // Kuning Keemasan
  "#606C38", // Hijau Tentara
  "#283618", // Hijau Tua
  "#FE4A49", // Merah Mawar
  "#2AB7CA", // Biru Samudra
  "#FED766", // Kuning Mentega
  "#E6E6EA", // Abu-Abu Putih
  "#F46036", // Oranye Bata
  "#2E4057", // Biru Batu
  "#D90368", // Merah Anggur Tua
  "#00CC99", // Hijau Tua Cerah
  "#6A0572", // Ungu Terang
  "#E1AD01", // Emas
  "#FFD700", // Kuning Emas
  "#DE3163", // Merah Mawar Gelap
  "#6495ED", // Biru Cornflower
  "#FF4500", // Oranye Merah Tua
  "#DA70D6", // Ungu Anggrek
  "#7FFF00", // Hijau Chartreuse
  "#D2691E", // Coklat Perunggu
  "#00CED1", // Cyan Tua
  "#DC143C", // Merah Crimson
  "#00FF7F", // Hijau Musim Semi
  "#FF1493", // Merah Muda Neon
  "#B8860B", // Coklat Emas Tua
  "#4682B4", // Biru Baja
  "#FFDAB9", // Peach
  "#B22222", // Merah Bata
  "#A52A2A", // Coklat Tua Gelap
  "#FF6347", // Merah Tomat
  "#008080", // Teal Gelap
  "#FFE4E1", // Pink Muda Lembut
  "#20B2AA", // Cyan Laut Tua
  "#BDB76B", // Kuning Olive
  "#00BFFF", // Biru Langit Menyala
  "#2F4F4F", // Abu-Abu Tua
  "#FFD700", // Kuning Keemasan
  "#CD5C5C", // Merah Salmon
  "#4B0082", // Indigo
  "#FFDEAD", // Kuning Peach Lembut
  "#DAA520", // Emas Gelap
  "#D8BFD8", // Ungu Thistle
  "#8B0000", // Merah Tua Gelap
  "#FF69B4", // Pink Cerah
  "#FFFACD", // Kuning Lemon Pucat
  "#8FBC8F", // Hijau Laut Tua
  "#8B4513", // Coklat Saddle
  "#FA8072", // Salmon
  "#7B68EE", // Biru Tua Terang
  "#E9967A", // Salmon Gelap
  "#BC8F8F", // Coklat Rosy
  "#FFEBCD", // Peach Muda
];

export const colorsChart = [
  "#FF5733",
  "#36A2EB",
  "#4CAF50",
  "#FFC107",
  "#9C27B0",
  "#E91E63",
  "#795548",
  "#03A9F4",
  "#FF9800",
  "#8BC34A",
  "#CDDC39",
  "#607D8B",
  "#FF6384",
  "#4BC0C0",
  "#FFCE56",
  "#9966FF",
  "#FF9F40",
  "#FF5733",
  "#C70039",
  "#900C3F",
  "#581845",
  "#00ACC1",
  "#009688",
  "#43A047",
  "#C0CA33",
  "#F57F17",
  "#EF6C00",
  "#D84315",
  "#6A1B9A",
  "#4A148C",
  "#1A237E",
  "#0D47A1",
  "#01579B",
  "#004D40",
  "#BF360C",
];

export const getRandomColorChart = () => {
  return colorsPie[Math.floor(Math.random() * colorsPie.length)];
};

export const generateDatasetWithColors = (question_answer) => {
  return question_answer.map((_, idx) => colorsChart[idx % colorsChart.length]);
};

const handleScrollSelect = async (
  e,
  dispatch,
  api,
  currentParams,
  setParams,
  value,
  label,
  stateSetter
) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;

  if (scrollHeight - scrollTop === clientHeight) {
    console.log("Scroll reached bottom");

    const nextPageNo = currentParams.pageNo + 1;

    // Update params for next page
    setParams((prevParams) => ({
      ...prevParams,
      pageNo: nextPageNo,
    }));

    try {
      // Fetch data with updated params
      const response = await dispatch(
        api({ ...currentParams, pageNo: nextPageNo })
      );

      const data = response.payload.data.data.map((item) => ({
        label: item[label],
        value: item[value],
      }));

      // Merge the new options with the existing ones
      stateSetter((prevOptions) => {
        const mergedOptions = [...prevOptions, ...data];
        console.log(mergedOptions, "mergedOptions");

        return mergedOptions;
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
};

export const getSettingValue = (settings, settingName) => {
  const setting = settings.find((item) => item.setting_name === settingName);
  return setting ? setting.setting_value : null;
};

export function generateUniqueCode() {
  return Date.now(); // Anda bisa menggunakan logika lain untuk menghasilkan kode unik
}
export function getAlignment(value) {
  // Cek apakah value adalah format tanggal (YYYY-MM-DD) atau timestamp (YYYY-MM-DD HH:mm:ss)
  const isDateFormat =
    typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}(\s\d{2}:\d{2}:\d{2})?$/.test(value);

  if (isDateFormat) return "left"; // Pastikan tanggal tetap left
  return !isNaN(parseFloat(value)) ? "right" : "left";
}

export const isUUID = (value) =>
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
    value
  );

export const transformValue = (value) => {
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (value === "Y") return "Yes";
  if (value === "N") return "No";
  return value;
};

export const handleSetOptionsMaster = (data, setter, key, value) => {
  if (data.length > 0) {
    setOptionsMaster(data, setter, key, value);
  }
};

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }

  console.log(text, "text");
  return text;
};
